import PropTypes from 'prop-types'
import { Form, Field } from 'react-final-form'
import validate from 'validate.js'
import { InputField, Button, CheckboxField, Icon } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import { EmailCaptureLegal } from '@mc/legal'

const EmailForm = ({ onSubmit, children, buttonType = 'tertiary' }) => {
  const { t } = useTranslation('@mc/next')

  return (
    <Form
      initialValues={{ email: '', terms: false }}
      onSubmit={onSubmit}
      validate={(values) =>
        validate(
          values,
          {
            email: {
              presence: {
                message: t('emailCaptureBanner.form.errors.emailIsRequired'),
              },
              email: {
                message: t('emailCaptureBanner.form.errors.invalidEmail'),
              },
            },
            terms: {
              presence: { message: t('emailCaptureBanner.form.errors.terms') },
              inclusion: {
                within: [true],
                message: t('emailCaptureBanner.form.errors.terms'),
              },
            },
          },
          { fullMessages: false },
        )
      }
      render={({ handleSubmit, submitError, submitting }) => (
        <form className='row flex-column flex-md-row' onSubmit={handleSubmit}>
          <div className='col-md-4 d-flex flex-column justify-content-center mc-text--center mc-text-md--left'>
            {children}
          </div>
          <div className='col-md-5 offset-md-1'>
            <Field
              id='email'
              autoComplete='email'
              component={InputField}
              name='email'
              label={t('emailCaptureBanner.form.label')}
              placeholder={t('emailCaptureBanner.form.placeholder')}
              type='email'
            />
            {submitError && (
              <label className='mc-text-x-small mc-text--error mc-text--bold'>
                <Icon className='mc-icon--2' kind='error' />
                {submitError}
              </label>
            )}
            <Field
              id='terms'
              className='mc-mt-2 align-items-center mc-text-x-small'
              component={CheckboxField}
              name='terms'
              label={
                <label className='mc-opacity--muted'>
                  {t('emailCaptureBanner.form.agree')}
                </label>
              }
            />
            <EmailCaptureLegal
              kind='submit'
              className='mc-mt-2 mc-text-x-small mc-opacity--muted'
            />
          </div>
          <div className='col-md-2'>
            <Button
              disabled={submitting}
              fullWidth
              kind={buttonType}
              type='submit'
              className='mc-mt-md-5'
            >
              {t('emailCaptureBanner.form.cta')}
            </Button>
          </div>
        </form>
      )}
    />
  )
}

EmailForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
  buttonType: PropTypes.string,
}

export default EmailForm
